export default "<p>student-my-classes wo rks! 1</p>\n"